<dx-popup
  [visible]="displayRemoveDialog()"
  (visibleChange)="displayRemoveDialog.set($event)"
  [width]="'40%'"
  [height]="'auto'"
  [maxHeight]="'85vh'"
  [resizeEnabled]="true"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="dialog-header">
    <div class="dialog-title">
      <i class="fas fa-trash"></i>
      <strong>Supprimer des points de livraison</strong>
    </div>
    <div class="dialog-actions">
      <yo-button
        iconClass="fas fa-check"
        tooltip="Supprimer les points de livraison sélectionnés"
        [theme]="ButtonThemeEnum.SUCCESS"
        (onClick)="detachSelectedPlc()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>
  </div>

  @if (plcToRemoveList().length > 0) {
    <span class="genlabel font-10">{{ plcToRemoveList().length }} points de livraison disponibles</span>
    <dx-list
      [dataSource]="plcToRemoveList()"
      keyExpr="id"
      selectionMode="all"
      [showSelectionControls]="true"
      [(selectedItems)]="selectedPlcToRemoveList"
      [searchEnabled]="true"
      searchExpr="libelle"
      [height]="'55vh'">
      <div *dxTemplate="let item of 'item'">
        <i class="fas fa-map-pin mg-r-5"></i> {{ item.libelle }}
        <span class="genlabel font-12">({{ item.adresse?.ville }})</span>
      </div>
    </dx-list>
  } @else {
    <span class="genlabel font-12">
      <i class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun point de livraison à supprimer
    </span>
  }

</dx-popup>
